"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_VALUE = exports.createItem = exports.createArea = exports.EMPTY_HINT = exports.TYPE = void 0;
const id_1 = require("../../../utils/id");
const types_1 = require("./types");
const constants_1 = require("../../constants");
const translation_1 = require("../../../translation");
const rich_text_1 = require("@vedalib/rich-text");
exports.TYPE = 'simulator';
exports.EMPTY_HINT = {
    text: (0, rich_text_1.textToRtValue)(''),
    position: types_1.HintPosition.BOTTOM,
    indicator: true,
    onHover: false,
    showCloseButton: true,
};
const createArea = () => ({
    id: (0, id_1.generateId)(),
    x: 30,
    y: 50,
    width: 60,
    height: 30,
    hint: exports.EMPTY_HINT,
    showClickableArea: true,
});
exports.createArea = createArea;
const createItem = (label) => ({
    value: (0, id_1.generateId)(),
    label: label || '',
    image: constants_1.imageValueWithObjectFit,
    overlay: null,
});
exports.createItem = createItem;
const item = {
    value: (0, id_1.generateId)(),
    label: `${(0, translation_1.t)('elements.simulator.label')} 1`,
    areas: [(0, exports.createArea)()],
    image: constants_1.imageValueWithObjectFit,
    overlay: null,
};
exports.DEFAULT_VALUE = {
    items: [item],
    showArea: true,
    navigation: types_1.SimulatorNavigation.FLEX_END,
    numbering: true,
};
